import { useCallback, useState } from "react";
import { useStripes } from "@folio/stripes/core";
import { resolveStripesUserId } from "../utils/columnPrefs";
import { DEFAULT_PAGE_SIZE, buildPageSizeStorageKey, parsePageSize, } from "../utils/pageSize";
var readStoredPageSize = function (storageKey) {
    try {
        return parsePageSize(localStorage.getItem(storageKey));
    }
    catch (_a) {
        return null;
    }
};
var writeStoredPageSize = function (storageKey, size) {
    try {
        localStorage.setItem(storageKey, String(size));
    }
    catch (error) {
        console.error("Error storing page size:", error);
    }
};
// One size for every PV list; a list's own default applies only until the user picks a size.
export var usePageSize = function (defaultSize) {
    if (defaultSize === void 0) { defaultSize = DEFAULT_PAGE_SIZE; }
    var stripes = useStripes();
    var storageKey = buildPageSizeStorageKey(resolveStripesUserId(stripes.user));
    var _a = useState(function () {
        return readStoredPageSize(storageKey);
    }), storedSize = _a[0], setStoredSize = _a[1];
    var setPageSize = useCallback(function (size) {
        setStoredSize(size);
        writeStoredPageSize(storageKey, size);
    }, [storageKey]);
    return { pageSize: storedSize !== null && storedSize !== void 0 ? storedSize : defaultSize, setPageSize: setPageSize };
};
